import { ParsedProjectFile } from '@arpeggi/shared'
import { useAuth } from '../../hooks/useAuth'
import { objectToFormData } from '../../utils/api'

export const useParsedProjectFilesAPI = () => {
  const { authenticatedPost } = useAuth()

  const createParsedProjectFile = async (projectFile: File) => {
    const { data } = await authenticatedPost<ParsedProjectFile>(
      '/api/v2/parsed-project-file',
      objectToFormData({ projectFile })
    )

    return data
  }

  return { createParsedProjectFile }
}
